export const DistributionPermissions = [1, 2, 5, 6, 9, 10, 13, 14];

export const EditIconPermissions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 14, 15];

export const ViewPeriodPermissions = [17, 19, 21, 23, 25, 27, 29, 31];
export const ShowNotePermissions = [3, 4, 7, 8, 11, 12, 15, 16];

export const PanelEditFieldPermissions = [1, 2, 4, 5, 6, 9, 10, 12, 13, 14];
export const EditInvoiceAccountingPeriod = [2, 4, 6, 10, 12, 14];

// Buttons

export const EditPeriodsButtonPermissions = [1, 3, 5, 9, 11, 13, 15];
export const EditPeriodButtonPermissions = [2, 4, 6, 10, 12, 14];

export const convertMultiButtonPermission = [7];
export const convertSingleButtonPermission = [8];

export const AssignMultipleButtonPermissions = [4, 8];
export const AssignSingleButtonPermissions = [3, 7, 11, 15];

export const CancelButtonPermissions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
export const BackButtonPermissions = [
  17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
];
export const DeleteButtonPermissions = [1, 2, 5, 6, 9, 10, 13, 14];
